import React from 'react'
import Benefits from './new/Benefits'
import Esub from './new/Esub'
import MiniSlider from './new/MiniSlider'
import ThreeGrid from './new/ThreeGrid'
import Tiles from './new/Tiles'
import ContentContainer from './new/ContentContainer'
import NotFoundBox from './new/atoms/NotFoundBox'
import Accordion from './new/Accordion'
import Testimonials from './new/Testimonials'
import DoubleTextContentContainer from './new/DoubleTextContentContainer'
import Signup from './new/Signup'
import Header from './new/Header'
import InfoBox from './new/InfoBox'
import Contactform from './new/Contactform'
import AccordionGroup from './new/AccordionGroup'
import LinkBox from './new/LinkBox'
import BlogHeader from './new/BlogHeader'
import SmallBusinessForm from './new/SmallBusinessForm'
import BlueChipForm from './new/BlueChipForm'
import BlueChipFormNew from './new/BlueChipFormNew'
import CancelBookingForm from './new/CancelBookingForm'
import ModifyBookingForm from './new/ModifyBookingForm'
import FadeContainer from './new/FadeContainer'

import obj2Arr from '../utils/obj2Arr'
import ImportIframe from './new/ImportIframe'
import MissingFFPoints from './new/MissingFFPoints'
import VelocityPromo from './new/VelocityPromo'
import MissingVPoints from './new/MissingVPoints'
import Signages from './new/Signages'

const validComponent = obj => {
  return obj !== undefined && obj[0].enable !== undefined && obj[0].enable == '1'
}

const DynamicContent = ({ content }) => {
  return obj2Arr(content).map((item, i) => {
    if (validComponent(item.benefits)) {
      return <Benefits key={`benefits${i}`} {...item.benefits[0]} />
    }
    if (validComponent(item.slider)) {
      return <MiniSlider key={`slider${i}`} {...item.slider[0]} />
    }
    if (validComponent(item.maillist)) {
      return <Esub key={`maillist${i}`} {...item.maillist[0]} />
    }
    if (validComponent(item.threegrid)) {
      return <ThreeGrid key={`threegrid${i}`} {...item.threegrid[0]} />
    }
    if (validComponent(item.fourgrid)) {
      return <Tiles key={`fourgrid${i}`} {...item.fourgrid[0]} />
    }
    if (validComponent(item.contentcontainer)) {
      return <ContentContainer key={`contentcontainer${i}`} {...item.contentcontainer[0]} />
    }
    if (validComponent(item.doubletextcontentcontainer)) {
      return (
        <DoubleTextContentContainer
          key={`doubletextcontentcontainer${i}`}
          {...item.doubletextcontentcontainer[0]}
        />
      )
    }
    if (validComponent(item.notfoundbox)) {
      return <NotFoundBox key={`notfoundbox${i}`} {...item.notfoundbox[0]} />
    }
    if (validComponent(item.accordion)) {
      return <Accordion key={`accordion${i}`} {...item.accordion[0]} />
    }
    if (validComponent(item.testimonials)) {
      return <Testimonials key={`testimonials${i}`} {...item.testimonials[0]} />
    }
    if (validComponent(item.signup)) {
      return <Signup key={`signup${i}`} {...item.signup[0]} />
    }
    if (validComponent(item.header)) {
      return <Header key={`header${i}`} {...item.header[0]} />
    }
    if (validComponent(item.infoBox)) {
      return <InfoBox key={`infoBox${i}`} {...item.infoBox[0]} />
    }
    if (validComponent(item.contactform)) {
      return <Contactform key={`contactform${i}`} {...item.contactform[0]} />
    }
    if (validComponent(item.accordiongroup)) {
      return <AccordionGroup key={`accordiongroup${i}`} {...item.accordiongroup[0]} />
    }
    if (validComponent(item.linkbox)) {
      return <LinkBox key={`linkbox${i}`} {...item.linkbox[0]} />
    }
    if (validComponent(item.blogheader)) {
      return <BlogHeader key={`blogheader${i}`} {...item.blogheader[0].blogheaderpost} />
    }
    if (validComponent(item.blogpostslider)) {
      return <Tiles smallerText key={`blogpostslider${i}`} blogpost {...item.blogpostslider[0]} />
    }
    if (validComponent(item.blogpthreegrid)) {
      return <ThreeGrid key={`blogpthreegrid${i}`} blogpost {...item.blogpthreegrid[0]} />
    }
    if (validComponent(item.smallBusinessForm)) {
      return <SmallBusinessForm key={`smallBusinessForm${i}`} {...item.smallBusinessForm[0]} />
    }
    if (validComponent(item.blueChipForm)) {
      return <BlueChipForm key={`blueChipForm${i}`} {...item.blueChipForm[0]} />
    }
    if (validComponent(item.blueChipFormNew)) {
      return <BlueChipFormNew key={`blueChipFormNew${i}`} {...item.blueChipFormNew[0]} />
    }
    if (validComponent(item.cancelBookingForm)) {
      return <CancelBookingForm key={`cancelBookingForm${i}`} {...item.cancelBookingForm[0]} />
    }
    if (validComponent(item.modifyBookingForm)) {
      return <ModifyBookingForm key={`modifyBookingForm${i}`} {...item.modifyBookingForm[0]} />
    }
    if (validComponent(item.importiframe)) {
      return <ImportIframe key={`importiframe${i}`} {...item.importiframe[0]} />
    }
    if (validComponent(item.missingFFPoints)) {
      return <MissingFFPoints key={`missingFFPoints${i}`} {...item.missingFFPoints[0]} />
    }
    if (validComponent(item.fadecontainer)) {
      return <FadeContainer key={`fadecontainer${i}`} {...item.fadecontainer[0]} />
    }
    if (validComponent(item.velocityPromo)) {
      return <VelocityPromo key={`velocityPromo${i}`} {...item.velocityPromo[0]} />
    }
    if (validComponent(item.missingVPoints)) {
      return <MissingVPoints key={`missingVPoints${i}`} {...item.missingVPoints[0]} />
    }
    if (validComponent(item.signages)) {
      return <Signages key={`signages${i}`} {...item.signages[0]} />
    }
  })
}

export default DynamicContent
